export const messages = {
  en: {
    tempCarPayment: {
      searchTitle: 'Search Conditions',
      inParkingTitle: 'Parking Vehicles',
      carNumPlaceholder: 'Please enter license plate number',
      carStatusPlaceholder: 'Please select vehicle status',
      selectCarStatus: 'Select vehicle status',
      inStatus: 'Entry Status',
      paidStatus: 'Payment Completed',
      outStatus: 'Exit Status',
      repayStatus: 'Re-payment due to timeout',
      entryStartTime: 'Entry start time',
      entryEndTime: 'Entry end time',
      search: 'Search',
      reset: 'Reset',
      inoutId: 'In/Out ID',
      carStatus: 'Vehicle Status',
      carNum: 'License Plate',
      inTime: 'Entry Time',
      payType: 'Payment Type',
      payableAmount: 'Payable Amount',
      paidAmount: 'Paid Amount',
      payTime: 'Payment Time',
      loadParkingAreaError: 'Failed to load parking areas',
      queryError: 'Query failed'
    }
  },
  zh: {
    tempCarPayment: {
      searchTitle: '查询条件',
      inParkingTitle: '在场车辆',
      carNumPlaceholder: '请输入车牌号',
      carStatusPlaceholder: '请选择车辆状态',
      selectCarStatus: '请选择车辆状态',
      inStatus: '进场状态',
      paidStatus: '支付完成',
      outStatus: '离场状态',
      repayStatus: '支付超时重新支付',
      entryStartTime: '进场开始时间',
      entryEndTime: '进场结束时间',
      search: '查询',
      reset: '重置',
      inoutId: '进出场编号',
      carStatus: '车辆状态',
      carNum: '车牌号',
      inTime: '进场时间',
      payType: '收费类型',
      payableAmount: '应收金额',
      paidAmount: '实收金额',
      payTime: '支付时间',
      loadParkingAreaError: '加载停车区域失败',
queryError: '查询失败'
    }
  },
  'zh-TW': {
    tempCarPayment: {
      searchTitle: '查詢條件',
      inParkingTitle: '在場車輛',
      carNumPlaceholder: '請輸入車牌號',
      carStatusPlaceholder: '請選擇車輛狀態',
      selectCarStatus: '請選擇車輛狀態',
      inStatus: '進場狀態',
      paidStatus: '支付完成',
      outStatus: '離場狀態',
      repayStatus: '支付超時重新支付',
      entryStartTime: '進場開始時間',
      entryEndTime: '進場結束時間',
      search: '查詢',
      reset: '重設',
      inoutId: '進出廠編號',
      carStatus: '車輛狀態',
      carNum: '車牌號',
      inTime: '進場時間',
      payType: '收費類型',
      payableAmount: '應收金額',
      paidAmount: '實收金額',
      payTime: '支付時間',
      loadParkingAreaError: '加載停車區域失敗',
      queryError: '查詢失敗'
    }
  }
}